import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const rootElement = document.getElementById("root");
const appTree = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

// SSG prerenderuje HTML — hydratujeme jen když prerendered cesta odpovídá aktuální URL.
// Jinak (SPA fallback pro /admin apod., případně obsah z jiné stránky) čistý client render.
const prerenderedPath = document.querySelector('meta[name="x-prerendered-path"]')?.getAttribute("content");
const currentPath = window.location.pathname.replace(/\/+$/, "") || "/";

if (rootElement.hasChildNodes() && prerenderedPath === currentPath) {
  ReactDOM.hydrateRoot(rootElement, appTree);
} else {
  if (rootElement.hasChildNodes()) rootElement.innerHTML = "";
  ReactDOM.createRoot(rootElement).render(appTree);
}
